import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useDebouncedCallback } from 'use-debounce';

import AdminHeader from '../../../components/header/AdminHeader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';
import CallexLoader from '../../../components/CallexLoader';
import { checkModulePermission } from '../../../utils/common';
import { useUserRolePermission } from '../../../store/slices/authSlice';
import {
  aiKeyListGet,
  aiKeyDelete,
  useAiKeyList
} from '../../../store/slices/tenantSlices/configurationSlice';
import AddAiKeyModal from './AddAiKeyModal';

const AiKey = () => {
  const dispatch = useDispatch();
  const aiKeyList = useAiKeyList();
  const userRolePermission = useUserRolePermission();

  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [filter, setFilter] = useState({
    search: undefined
  });

  const fetchAiKeyList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(aiKeyListGet(payload)).unwrap();
    } catch (error) {
      console.error('Error fetching AI key list:', error);
    } finally {
      setIsLoading(false);
    }
  }, 500);

  useEffect(() => {
    fetchAiKeyList();
  }, [filter]);

  const handleDelete = async () => {
    try {
      const response = await dispatch(aiKeyDelete(isDeleteId)).unwrap();
      if (response && response.success) {
        toast.success(response.message || 'Record deleted successfully');
        fetchAiKeyList();
        setIsDeleteId(null);
      }
    } catch (error) {
      console.error('Error deleting AI key:', error);
      toast.error('Failed to delete API Key');
    }
  };

  const toggleAddModal = () => setIsAddModalOpen(!isAddModalOpen);

  return (
    <div>
      <AdminHeader
        title="AI Key"
        isExpandSearch
        isAdd
        onAddClick={toggleAddModal}
        isAddDisabled={!checkModulePermission('is_add', 'AI Key', userRolePermission) || aiKeyList?.data?.length > 0}
        addBtnName="Add AI Key"
        searchPlaceholder="Search AI Keys"
        search={filter.search}
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />

      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          <CallexLoader />
        </Card>
      ) : aiKeyList?.data?.length > 0 &&
        checkModulePermission('is_view', 'AI Key', userRolePermission) ? (
        <div className="p-0 position-relative m-0">
          <Card className="p-0 position-relative m-0">
            <div className="daily-report-table" style={{ height: 'calc(100vh - 170px)' }}>
              <table className="report-list-table">
                <thead>
                  <tr>
                    <th>API Key</th>
                    <th className="text-center" style={{ width: '90px' }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {aiKeyList?.data?.map((item) => (
                    <tr key={item.id}>
                      <td>{item.api_key}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div
                            className={`cursor-pointer text-danger ${!checkModulePermission('is_delete', 'AI Key', userRolePermission) &&
                              'callex-disabled'
                              }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission('is_delete', 'AI Key', userRolePermission)
                                ) {
                                  setIsDeleteId(item.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          No data available
        </Card>
      )}

      <AddAiKeyModal
        isOpen={isAddModalOpen}
        toggle={toggleAddModal}
        refreshList={fetchAiKeyList}
      />

      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default AiKey;
